import React from 'react';
import { usePagination, useSortBy, useTable } from 'react-table';
import notfound from '../../../Assets/images/il-empty.svg';
import moment from 'moment';
import { Form, Formik } from 'formik';
import Button from "../../../Components/Button/Button";
import Exports from '../../../Components/Exports/Exports';
import PaginationComponent from '../../../Components/PaginationTableServer/PaginationTableServer';
import RangeDatePicker from '../../../Components/RangeDatePicker/RangeDatePicker';
import SelectCheckField from '../../../Components/SelectCheckField/SelectCheckField';
import BitacoraIrdmField from './BitacoraIrdmField';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import validations from '../../../Utils/Validations/Validations';
import { ObtenerIndicadoresExigenciasPorAreaNegocio } from '../Services/ObtenerIndicadoresExigenciasPorAreaNegocio';

const BitacoraHallazgoTable = ({ columns, data = [], fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, handlerModal, listadoEstado = [], listadoTipoHallazgo = [] }) => {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,
		pageCount,
		gotoPage,
		setSortBy,
		state: { pageIndex, pageSize, sortBy }
	} = useTable(
		{
			columns,
			data,
			initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy },
			manualPagination: true,
			pageCount: controlledPageCount,
			autoResetPage: false,
			autoResetSortBy: false,
			manualSortBy: true
		},
		useSortBy,
		usePagination
	);

	const { usuario } = useLogin();
	const saltarEfectoTablaInicial = React.useRef(false);
	const busquedaInicialEjecutada = React.useRef(false);
	const formikRef = React.useRef();
	const [indicadorTotal, setIndicadorTotal] = React.useState([]);
	const [listadoIndicadoresId, setListadoIndicadoresId] = React.useState([]);
	const [listadoExigenciasId, setListadoExigenciasId] = React.useState([]);
	const [idbimAplicado, setIdbimAplicado] = React.useState("");
	const listaAreaNegocioSeleccion = usuario ? usuario.listaAreaNegocio ? usuario.listaAreaNegocio.map(x => { return { value: x.id.toString(), label: x.descripcion } }) : [] : [];
	const [initialValues, setInitialValues] = React.useState({
		business: listaAreaNegocioSeleccion.map(x => { return x.value.toString() }),
		indicadores: '',
		exigencia: '',
		periodo2: [moment().subtract(1, 'M').toDate(), new Date()],
		idbim: ''
	});
	const [valoresFormularioEnvio, setValoresFormularioEnvio] = React.useState({
		paginacion: {
			numeroPagina: pageIndex,
			cantidadRegistros: pageSize,
			orderByAscending: false,
			ordenadoPor: "fechaCreacion"
		},
		datosBusqueda: {
			idUsuario: usuario.id,
			fechaInicio: moment().subtract(1, 'M').format(),
			fechaFin: moment().format(),
			exportacion: false,
			idNegocio: listaAreaNegocioSeleccion.map(x => { return Number(x.value) }),
			idIndicador: [],
			idExigencia: [],
			IdBim: ""
		}
	});
	const valoresFormularioEnvioRef = React.useRef(valoresFormularioEnvio);
	valoresFormularioEnvioRef.current = valoresFormularioEnvio;
	const mostrarModal = (e, row) => {
		e.preventDefault();
		handlerModal(row);
	};

	const descargar = () => {
		const formularioExportacion = {
			...valoresFormularioEnvioRef.current,
			paginacion: {
				...valoresFormularioEnvioRef.current.paginacion,
			},
			datosBusqueda: {
				...valoresFormularioEnvioRef.current.datosBusqueda,
			},
		};
		fetchData({ formulario: formularioExportacion, pageIndex: pageIndex, sortBy, exportacion: true });
	};

	const buscarHallazgos = (values) => {
		const idbim = (values.idbim || "").trim();
		const formEnvio = {
			...valoresFormularioEnvio,
			paginacion: {
				numeroPagina: 0,
				cantidadRegistros: pageSize,
				orderByAscending: false,
				ordenadoPor: "fechaCreacion"
			},
			datosBusqueda: {
				...valoresFormularioEnvio.datosBusqueda,
				idUsuario: usuario.id,
				fechaInicio: values.periodo2[0],
				fechaFin: values.periodo2[1],
				idNegocio: values.business !== "" ? values.business.map(Number) : [],
				idIndicador: values.indicadores !== "" ? values.indicadores.map(x => { return Number(x) }) : [],
				idExigencia: values.exigencia !== "" ? values.exigencia.map(x => { return Number(x) }) : [],
				IdBim: idbim,
				exportacion: false
			}
		};

		setIdbimAplicado(idbim);
		setValoresFormularioEnvio(formEnvio);
		valoresFormularioEnvioRef.current = formEnvio;
		setPagination({
			pageIndex: formEnvio.paginacion.numeroPagina,
			pageSize: formEnvio.paginacion.cantidadRegistros,
			sortBy: []
		});
		setSortBy([]);
		gotoPage(0);
		fetchData({ formulario: formEnvio, pageIndex: 0, sortBy: [] });
	};

	const obtenerValoresInicialesFiltros = () => ({
		business: listaAreaNegocioSeleccion.map(x => { return x.value.toString() }),
		indicadores: listadoIndicadoresId.map(x => { return x.value }),
		exigencia: '',
		periodo2: [moment().subtract(1, 'M').toDate(), new Date()],
		idbim: ''
	});

	const limpiarIdbimAplicado = () => {
		const values = obtenerValoresInicialesFiltros();
		formikRef.current?.resetForm({ values });
		setInitialValues(values);
		buscarHallazgos(values);
	};

	const obtenerExigenciasPorIndicadores = (indicadores, selectedIds) => {
		const ids = Array.isArray(selectedIds) ? selectedIds.map(Number) : indicadores.map((indicador) => indicador.indicadorId);

		return indicadores
			.filter((indicador) => ids.includes(Number(indicador.indicadorId)))
			.flatMap((indicador) =>
				(indicador.exigencias || []).map((exigencia) => ({
					value: exigencia.id,
					label: `${indicador.sigla} - ${exigencia.sigla} - ${exigencia.descripcion}`,
				}))
			);
	};

	const actualizarListasIndicadorExigencia = (indicadores, selectedIds, setFieldValue) => {
		const indicadoresOptions = indicadores.map((indicador) => ({
			value: indicador.indicadorId,
			label: `${indicador.sigla}`,
		}));
		const exigenciasOptions = obtenerExigenciasPorIndicadores(indicadores, selectedIds);

		setIndicadorTotal(indicadores);
		setListadoIndicadoresId(indicadoresOptions);
		setListadoExigenciasId(exigenciasOptions);

		const indicadoresValue = selectedIds && selectedIds.length > 0 ? selectedIds.map(Number) : indicadoresOptions.map((x) => x.value);

		if (setFieldValue) {
			setFieldValue("indicadores", indicadoresValue);
			setFieldValue("exigencia", "");
		} else {
			setInitialValues((values) => ({
				...values,
				indicadores: indicadoresValue,
				exigencia: '',
			}));
		}
	};

	const cargarIndicadoresExigencias = async (areaIds, setFieldValue) => {
		const idsArea = Array.isArray(areaIds) ? areaIds.map(Number) : [];
		if (idsArea.length === 0) {
			actualizarListasIndicadorExigencia([], undefined, setFieldValue);
			return;
		}

		const respuestas = await Promise.all(
			idsArea.map((areaNegocioId) =>
				ObtenerIndicadoresExigenciasPorAreaNegocio({
					idUsuario: usuario.id,
					areaNegocioId,
				})
			)
		);

		const indicadores = respuestas
			.filter((respuesta) => respuesta && respuesta.status === 200 && Array.isArray(respuesta.data))
			.flatMap((respuesta) => respuesta.data);
		const indicadoresUnicos = indicadores.reduce((acc, indicador) => {
			const actual = acc.get(indicador.indicadorId);
			if (!actual) {
				acc.set(indicador.indicadorId, {
					...indicador,
					exigencias: indicador.exigencias || [],
				});
				return acc;
			}

			const exigencias = [...(actual.exigencias || []), ...(indicador.exigencias || [])];
			acc.set(indicador.indicadorId, {
				...actual,
				exigencias: [...new Map(exigencias.map((exigencia) => [exigencia.id, exigencia])).values()],
			});
			return acc;
		}, new Map());
		actualizarListasIndicadorExigencia([...indicadoresUnicos.values()], undefined, setFieldValue);
	};

	const changeAreaNegocio = (value, setFieldValue) => {
		setFieldValue("business", value);
		if (!Array.isArray(value) || value.length === 0) {
			setFieldValue("business", "");
			setFieldValue("indicadores", "");
			setFieldValue("exigencia", "");
			setInitialValues((values) => ({
				...values,
				business: '',
				indicadores: '',
				exigencia: '',
			}));
			actualizarListasIndicadorExigencia([], undefined, setFieldValue);
			return;
		}
		cargarIndicadoresExigencias(value, setFieldValue);
	};

	const changeIndicador = (value, setFieldValue) => {
		const exigenciasFiltradas = obtenerExigenciasPorIndicadores(indicadorTotal, value);
		setListadoExigenciasId(exigenciasFiltradas);
		setFieldValue("indicadores", value);
		setFieldValue("exigencia", "");
	};

	React.useEffect(() => {
		if (listaAreaNegocioSeleccion.length > 0) {
			cargarIndicadoresExigencias(listaAreaNegocioSeleccion.map(x => { return x.value }));
		}
	}, []);

	React.useEffect(() => {
		if (!busquedaInicialEjecutada.current && listadoIndicadoresId.length > 0) {
			busquedaInicialEjecutada.current = true;
			const formEnvio = {
				...valoresFormularioEnvio,
				datosBusqueda: {
					...valoresFormularioEnvio.datosBusqueda,
					idNegocio: listaAreaNegocioSeleccion.map(x => { return Number(x.value) }),
					idIndicador: listadoIndicadoresId.map(x => { return Number(x.value) }),
					idExigencia: [],
					IdBim: ""
				}
			};
			setValoresFormularioEnvio(formEnvio);
			valoresFormularioEnvioRef.current = formEnvio;
			saltarEfectoTablaInicial.current = true;
			fetchData({ formulario: formEnvio, pageIndex, sortBy });
		}
	}, [listadoIndicadoresId]);

	React.useEffect(() => {
		if (listadoIndicadoresId.length > 0) {
			if (saltarEfectoTablaInicial.current) {
				saltarEfectoTablaInicial.current = false;
				return;
			}
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
			setPagination(values => ({
				...values,
				sortBy: sortBy
			}));
		}
	}, [pageIndex, sortBy]);

	return (
		<div>
			<div className={`d-flex flex-column flex-lg-row justify-content-between align-items-lg-start gap-3 ${idbimAplicado ? 'mb-0' : 'mb-5'}`}>
				<Formik
					enableReinitialize
					initialValues={initialValues}
					innerRef={formikRef}
					validate={validations}
					onSubmit={(values) => {
						buscarHallazgos(values);
					}}
				>
					{({ setFieldValue, setFieldTouched }) => (
						<Form className="form mb-0">
							<div className="tools order-1 order-lg-0 align-items-start">
								<SelectCheckField
									name="business"
									label='Area de negocio'
									options={listaAreaNegocioSeleccion}
									onChange={(e, value) => { changeAreaNegocio(value, setFieldValue) }}
									onBlur={setFieldTouched}
									isMulti={true}
									backdrop="static"
								/>
								<SelectCheckField
									name="indicadores"
									label='Indicadores'
									options={listadoIndicadoresId}
									onChange={(e, value) => { changeIndicador(value, setFieldValue) }}
									onBlur={setFieldTouched}
									isMulti={true}
								/>
								<SelectCheckField
									name="exigencia"
									label='Exigencia'
									options={listadoExigenciasId}
									onChange={setFieldValue}
									onBlur={setFieldTouched}
									isMulti={true}
								/>
								<RangeDatePicker
									startMaxDate={new Date()}
									startMinDate={null}
									endMaxDate={new Date()}
									endMinDate={null}
									name="periodo2"
									onChange={setFieldValue}
									onBlur={setFieldTouched}
								/>
								<div className="bitacora-irdm-filter bitacora-irdm-filter--hallazgo">
									<BitacoraIrdmField
										name="idbim"
										label="IDBIM"
										type="text"
										placeholder="Ingresar"
										autoComplete="off"
									/>
								</div>
								<Button type="submit" design="btn-primary">Buscar</Button>
							</div>
						</Form>
					)}
				</Formik>
				<div className="bitacora-filter-actions order-0 order-lg-1">
					<div className="exports" style={{ visibility: data.length > 0 ? 'visible' : 'hidden' }}>
						<Exports descargar={() => descargar()} />
					</div>
				</div>
			</div>
			{idbimAplicado &&
				<div style={{ marginTop: "20px", marginBottom: "24px" }}>
					<span className="datamart-applied-filter">
						<span className="datamart-applied-filter__label">{idbimAplicado}</span>
						<button type="button" className="datamart-applied-filter__close" onClick={limpiarIdbimAplicado} aria-label="Limpiar filtro IDBIM">
							<i className="ico-close"></i>
						</button>
					</span>
				</div>
			}
			<div className="table-responsive brd-top">
				<table className="table" {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup) => {
							const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
							return (
							<tr key={hgKey} {...hgProps}>
								{headerGroup.headers.map((column) => {
									const colHeaderProps = data.length > 0
										? column.getHeaderProps(column.getSortByToggleProps(), { className: column.className })
										: column.getHeaderProps();
									const { key: colKey, ...colProps } = colHeaderProps;
									return data.length > 0 ? (
										<th key={colKey} {...colProps}>
											<span className="d-flex align-items-center gap-1">
												{column.render('Header')}
												<>
													{column.isSorted && data.length > 0 ?
														(column.isSortedDesc ?
															<i className="ico-chevron-down"></i>
															:
															<i className="ico-chevron-up"></i>
														) :
														<>
															<i className="ico-sort fs-7"></i>
														</>
													}
												</>
											</span>
										</th>
									) : (
										<th key={colKey} {...colProps}>
											<span className="d-flex align-items-center gap-1">
												{column.render('Header')}
											</span>
										</th>
									)
								})}
								<th className="text-center">Detalle</th>
							</tr>
							)
						})}
					</thead>
					<tbody {...getTableBodyProps()}>
						{
							page.length > 0 ? page.map((row) => {
								prepareRow(row);
								const { key: rowKey, ...rowProps } = row.getRowProps();
								return (
									<tr key={rowKey} {...rowProps}>
										{row.cells.map((cell) => {
											const { key: cellKey, ...cellProps } = cell.getCellProps({
												className: cell.column.className
											});
											return <td key={cellKey} {...cellProps}>
												{cell.render('Cell')}
											</td>;
										})}
										<td className="text-center">
											<button className="link text-pewter-blue fs-4" onClick={(e) => mostrarModal(e, row.original)}>
												<i className="ico-search"></i>
											</button>
										</td>
									</tr>
								);
							}) : <tr>
								<td colSpan={headerGroups[0].headers.length + 1}>
									<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
										<img className="mb-3" src={notfound} alt="" />
										<p className="mb-0 text-primary">{"No se encuentran resultados de tu b\u00fasqueda."}</p>
									</div>
								</td>
							</tr>
						}
					</tbody>
				</table>
			</div>
			{
				data.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={false}
					setPagination={setPagination}
				/>
			}
		</div>
	);
};

export default BitacoraHallazgoTable;
